import { Component, ElementRef, OnInit } from '@angular/core';

import { ScrollContainerService } from '@frontend/sports/common/core/utils/scroll-container';
import { Observable } from 'rxjs';

import { ColumnLayoutService } from '../../layout/column-layout.service';
import { LayoutColumn } from '../../layout/layout.model';
import { WidgetRightColumnContent, WidgetRightColumnService } from './widget-right-column.service';

@Component({
    selector: 'ms-widget-column',
    templateUrl: './widget-column.component.html',
    providers: [ScrollContainerService],
    standalone: false,
})
export class WidgetColumnComponent implements OnInit {
    content$: Observable<WidgetRightColumnContent>;

    constructor(
        service: WidgetRightColumnService,
        private scrollContainer: ScrollContainerService,
        private elementRef: ElementRef,
        private columnLayout: ColumnLayoutService,
    ) {
        this.content$ = service.asObservable();
    }

    ngOnInit(): void {
        this.columnLayout.register({
            component: WidgetColumnComponent,
            location: LayoutColumn.Right,
        });

        this.scrollContainer.setTarget(this.elementRef.nativeElement);
    }
}
